"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _MoveUp = _interopRequireDefault(require("@rsuite/icon-font/lib/action/MoveUp"));

// Generated by script, don't edit it please.
var MoveUp = (0, _createSvgIcon["default"])({
  as: _MoveUp["default"],
  ariaLabel: 'move up',
  category: 'action',
  displayName: 'MoveUp'
});
var _default = MoveUp;
exports["default"] = _default;
module.exports = exports.default;